'use client'
export { assertPackageVersion } from './lib/assertPackageVersion/assertPackageVersion.js';
